var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('b',[_vm._v("Accès refusé")])]),_c('p',[_vm._v("Vous n'êtes pas autorisé à accéder à cette partie de l'application.")])])}]

export { render, staticRenderFns }